import React from "react";
import { Layout } from "../../layouts/Layout";
import { ContactAreaInner } from "../../components/ContactAreas/ContactAreaInner";
import { ContactExpectArea } from "../../components/ContactAreas/ContactExpectArea";
import { ContactRequestArea } from "../../components/ContactAreas/ContactRequestArea";
import { ContactAreaMap } from "../../components/ContactAreas/ContactAreaMap";

const ContactPage = () => {
  return (
    <Layout breadcrumb={"Contact"} title={"Contact Silverwave"}>
      {/* contact-area */}
      <ContactAreaInner />

      <ContactRequestArea />
      <ContactExpectArea />

      {/* map */}
      <ContactAreaMap />
    </Layout>
  );
};

export default ContactPage;
